import { toasts as EnUsToasts } from '../en-us/toasts';
import { AgResourceLanguage } from '../types';

export const toasts: AgResourceLanguage['toasts'] = {
  ...EnUsToasts,
  useChangeShippingMethod: {
    ...EnUsToasts.useChangeShippingMethod,
    nextOrderMethodChanged: 'Método de envío para el próximo pedido modificado con éxito',
    subscriptionMethodChanged: 'Método de envío para la suscripción modificado con éxito'
  },
  commonError: 'Algo salió mal. Inténtalo de nuevo',
  shippingBillingAddress: {
    ...EnUsToasts.shippingBillingAddress,
    errorZipCode: 'Introduce un código postal válido',
    errorHtmlTag: 'no puede contener',
    successNextOrder: 'Dirección de envío para el próximo pedido modificada con éxito',
    successSubscription: 'Dirección de envío para la suscripción modificada con éxito',
    successCheckout: 'Dirección de envío modificada con éxito'
  },
  changePaymentMethod: {
    ...EnUsToasts.changePaymentMethod,
    cantRemovePaymentMethod: 'No se puede eliminar el método de pago: ID de cliente incorrecta',
    removedPaymentMethod: 'Método de pago eliminado y modificado con éxito',
    changedPaymentMethod: 'Método de pago modificado con éxito',
    incorrectId: 'ID de pedido incorrecta'
  },
  orderCreated: 'Pedido creado con éxito',
  migrationToV53: {
    title: '¡Tu AG1 está actualizado!',
    description: 'Su suscripción ahora está en la versión mejorada de AG1.'
  }
};
